/**
 * Download Word document button component.
 */
interface DownloadButtonProps {
  downloadUrl: string | null
  onDownload: () => void
  disabled?: boolean
}

export const DownloadButton: React.FC<DownloadButtonProps> = ({
  downloadUrl,
  onDownload,
  disabled = false,
}) => {
  if (!downloadUrl) {
    return (
      <div className="text-center py-4">
        <p className="text-sm text-gray-500">
          Download not available for this report
        </p>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center space-y-2">
      <a
        href={downloadUrl}
        download
        onClick={onDownload}
        className={`btn-primary inline-flex items-center px-6 py-3 ${
          disabled ? 'opacity-50 cursor-not-allowed' : ''
        }`}
      >
        <svg
          className="w-5 h-5 mr-2"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
          />
        </svg>
        Download Word Document
      </a>
      <p className="text-xs text-gray-500">
        Link expires in 15 minutes
      </p>
    </div>
  )
}
